export default {
  title: "FinOps & Cost Estimation",
  subtitle: "Cloud infrastructure cost analysis",
  kpi: {
    budgetUsage: "Budget Usage",
    forecast: "Forecast (30d)",
    savingsPotential: "Savings Potential",
    recommendations: "recommendations",
    vsbudget: "vs budget",
    projects: "Projects",
    architectures: "Architectures",
    totalCost: "Total Cost"
  },
  breadcrumb: {
    global: "Global",
    project: "Project",
    architecture: "Architecture"
  },
  views: {
    global: "Global View",
    project: "Project",
    architecture: "Architecture",
    globalSummary: "Global Summary",
    costsByProject: "Costs by Project",
    architectures: "Architectures",
    noProjectsFound: "No projects found",
    noArchitecturesFound: "No architectures in this project",
    unsupportedResources: "Unsupported resources",
    createProject: "Create project",
    createProjectCta: "Create a project and architecture to see cost estimates.",
    noDataAvailable: "No data available"
  },
  projectCard: {
    architecture: "architecture",
    architectures: "architectures",
    resource: "resource",
    resources: "resources",
    error: "Error"
  },
  costBreakdown: {
    title: "💰 Cost Breakdown",
    subtitle: "Breakdown by cloud provider",
    sortBy: "Sort by",
    sortByCost: "Cost (descending)",
    sortByName: "Name (A-Z)",
    perMonth: "per month",
    perHour: "hour",
    resources: "resource",
    resources_plural: "resources",
    ofTotal: "of total"
  },
  costChart: {
    title: "📊 Cost Evolution",
    monthly: "Monthly",
    yearly: "Yearly",
    comparison: "Comparison",
    totalCost: "Total cost",
    averageCost: "Average cost",
    evolution: "Evolution",
    chartType: "Chart type",
    pieChart: "📊 Pie chart",
    barChart: "📈 Bar chart",
    groupBy: "Group by",
    provider: "☁️ Provider",
    type: "🔧 Type",
    region: "🌍 Region"
  },
  resourceTypes: {
    compute: "Compute",
    storage: "Storage",
    database: "Database",
    network: "Network",
    other: "Other"
  },
  fields: {
    resourceName: "Resource name",
    resourceType: "Resource type",
    sku: "SKU",
    region: "Region",
    monthlyCost: "Monthly cost",
    hourlyCost: "Hourly cost",
    currency: "Currency"
  },
  messages: {
    loadError: "Error loading cost data",
    noData: "No cost data available",
    calculating: "Calculating costs...",
    disclaimer: "Prices are indicative and may vary based on actual usage conditions, negotiated discounts, and cloud provider pricing variations."
  },
  export: {
    title: "Export analysis",
    pdf: "Export as PDF",
    excel: "Export as Excel",
    csv: "Export as CSV"
  },
  filters: {
    title: "Filters",
    provider: "Provider",
    project: "Project",
    architecture: "Architecture",
    dateRange: "Date range",
    all: "All"
  },
  optimization: {
    title: "Optimization Recommendations",
    loading: "Analyzing optimization opportunities...",
    noData: "No optimization data available",
    noRecommendations: "No recommendations for this filter",
    currentCost: "Current cost",
    optimizedCost: "Optimized cost",
    potentialSavings: "Potential savings",
    reduction: "reduction",
    recommendationsCount: "recommendations",
    highPriority: "high priority",
    mediumPriority: "medium priority",
    lowPriority: "low priority",
    all: "All",
    high: "High priority",
    medium: "Medium",
    low: "Low",
    severity: {
      high: "High",
      medium: "Medium",
      low: "Low"
    },
    effort: {
      low: "Low",
      medium: "Medium",
      high: "High"
    },
    impact: {
      low: "Low",
      medium: "Medium",
      high: "High"
    },
    details: {
      currentCost: "Current cost:",
      optimizedCost: "Optimized cost:",
      effort: "Effort:",
      impact: "Impact:",
      suggestedSku: "Suggested SKU:",
      suggestedTier: "Suggested tier:"
    }
  }
};
